import { AuthGuard } from '@onesource/components';
import { isLoggedIn } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy } from 'react';

const BlackFridayDealsPage = lazy(() => import('src/pages/black-friday-deals'));

// Full-width sales page with its own header and footer, so it skips the dashboard layout.
export const Route = createFileRoute('/black-friday-deals')({
  // Logged-out visitors come straight back here after login instead of landing on the dashboard.
  beforeLoad: ({ location }) => {
    if (!isLoggedIn()) {
      throw redirect({ to: '/auth/login', search: { redirect: location.href } });
    }
  },
  component: () => (
    <AuthGuard>
      <BlackFridayDealsPage />
    </AuthGuard>
  ),
});
